import * as React from "react";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { WizardLinter, EWizardLinterStatus } from "../../../../../../../Shared/Process/Process/WizardLinter";
import { EWizardLinterHelper } from "../../../../NewBusinessWizard/Resource/EWizardLinterHelper";
import { CrystallisationDetailsSection } from "../../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { LTABreakdownDetails } from "../../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { RegularCrystallisation } from "../../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { TaxFreeLumpSumPayment } from "../../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { DrawdownTypeOption } from "../../../../Common/SIPP/DrawdownDetails/DrawdownType";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { LessThanAge } from "../../../../Common/Helpers/PensionHelper";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { SectionHeader } from "../../../../Common/SharedComponents";
import { DIAC } from "../../../../Common/SIPP/DrawdownDetails/DIAC";
import { OAC } from "../../../../Common/AdviserCharges/Components/OAC";
import { ChooseAssetsToSell } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import {
    getChooseAssetsToSellTable,
    hasEnhancedPensionProtection,
    showChooseAssetstoSell,
    hasPrimaryProtection,
    hasEnhancedProtectionWithPclsProtection
} from "../../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellTable } from "../../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { ProtectionInformation } from "../../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { IllHealth } from "../../../../Common/SIPP/DrawdownDetails/IllHealth";
import { DrawdownCalculationAction } from "../../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { PartLoading } from "../../../../../../../../react-core/Html/PartLoading";
import { DrawdownModel } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { getQueryParameters } from "../../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ApplyModel } from "../../../../../../../../Wrap/Models/Models/Processes/Apply/ApplyModel";
import { NewBusinessAction } from "../../../Actions/NewBusinessAction";
import { NewBusinessStore } from "../../../Stores/Variable";
import { DrawdownPriceLock } from "../../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { PreADayPensionDetails } from "../../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import { Information } from "../../../../Common/SIPP/DrawdownDetails/Information";
import { PensionType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionType";
import { CrystallizationPerContribution } from "../../../../Common/SIPP/DrawdownDetails/CrystallizationPerContribution";
import { PensionProtection } from "../../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { ChooseAssetsToSellAssets } from "../../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { ChooseAssetsToSellFor } from "../../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { InvestmentPathSelection } from "../../../../Common/SIPP/DrawdownDetails/InvestmentPathSelection";
import { ChargesOnIllustration } from "../../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { isRestrictedToPensionContribution } from "../../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { HistoricCrystallisationPage } from "../../../../../../../../Wrap/Models/Domains/Drawdown/HistoricCrystallisationPage";
import { ITFLSAction } from "../../../../TopUpWithITFLSWizard/Actions/ITFLSAction";
import { ProductType } from "../../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { IsRestrictedToPensionContributionWarningText, drawdownDetailsMessage } from "../../../../Common/Resource/Contents";
import { PensionPathwayInvestmentOption } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";
import { UserStore } from "../../../../../../../Dashboard/Stroes/Variable";
import { PensionArrangementType } from "../../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { PensionArrangementAction } from "../../../../PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { TableKeys } from "../../../../Common/SIPP/DrawdownDetails/Resource/Constant";

interface IDrawdownDetailsProps extends IProcessComponentProps {
    data: ApplyModel;
}

interface IDrawdownDetailsState {
    isLoading: boolean;
    originType: DrawdownType;
    assetsTable: ChooseAssetsToSellAssets[];
    historicCrystallisation: HistoricCrystallisationPage;
    TailoredDrawdownAllowed: boolean;
    AdviceGiven: boolean;
    hasDrawdownArrangement?: boolean;
}

export class DrawdownDetails extends ProcessComponent<IDrawdownDetailsProps, IDrawdownDetailsState> {
    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false,
            originType: null,
            assetsTable: [],
            historicCrystallisation: null,
            TailoredDrawdownAllowed: false,
            AdviceGiven: false,
            hasDrawdownArrangement: false,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        if (!this.props.data.PensionApply?.AdviceGiven) {
            this.onDataChange(this.props.onChange, { AdviceGiven: true }, this.props.data, "PensionApply");
        }
        this.setState({ AdviceGiven: this.props.data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers?.PersonalRecommendation ?? false })
        this.setState({ assetsTable: getChooseAssetsToSellTable(this.props.data.PensionApply) });
        if (
            !LessThanAge(55, JsonDateParser.toDate(this.props.data?.ClientDetails?.DateOfBirth)) &&
            !this.props.data?.PensionApply?.DrawdownModel?.InstructionId
        ) {
            this.setState({ isLoading: true });
            const params = getQueryParameters();
            DrawdownCalculationAction.postDrawdown(
                this.props.data?.PensionApply?.HierarchyId,
                null,
                (drawdownModel: DrawdownModel) => {
                    NewBusinessAction.getInstruction(params["id"]);
                    this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                }
            );
        }
        ITFLSAction.getHistoricCrystallisation(
            this.props.data.PensionApply.ExistingPensionSubAccountHierarchyId,
            (result) => {
                this.setState({ historicCrystallisation: result });
            }
        );
        this.setState({
            TailoredDrawdownAllowed: this.props.data?.PensionApply?.PreRetirementInstrumentSelections?.Instruments.filter(
                (ele) =>
                    (ele.Instrument.Type == ProductType.OffPlatform))
                .every(ele => ele.Instrument.TailoredDrawdownAllowed == true)
        });

        if (this.props.data?.PensionApply?.ExistingPensionSubAccountHierarchyId) {
            PensionArrangementAction.GetPensionArrangementDetails(this.props.data.PensionApply.ExistingPensionSubAccountHierarchyId, true, (v) => {
                this.setDrawdownArrangement(v);
            });
        }
    }

    isValid() {
        const flag = super.isValid();
        var isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        if (!this.state.AdviceGiven && !isNotFirstCrystallisation && !UserStore.getUserInfo().IsInternalUser) {
            this.props.showErrorMsgPopUp(["To continue, you must have given financial advice."]);
            return false;
        }
        var isRestrictedProtection = false;
        if (this.props.data?.PensionApply?.HasPensionProtection && this.props.data?.PensionApply?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                this.props.data?.PensionApply?.PensionProtection
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }
        if (this.state.TailoredDrawdownAllowed == false && this.props.data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Regular) {
            return false
        }

        return flag && !isRestrictedProtection;
    }

    private setDrawdownArrangement(arrangementDetails) {
        arrangementDetails.forEach(v => {
            if (v.Type != PensionArrangementType.Accumulation) {
                this.setState({ hasDrawdownArrangement: true });
            }
        });
    }

    private getComponentProps = (data: ApplyModel, onChange) => {
        return {
            data: data?.PensionApply?.DrawdownModel,
            onChange: (v) =>
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "PensionApply"),
                    v,
                    data.PensionApply,
                    "DrawdownModel"
                ),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: this.props.data?.PensionApply?.HierarchyId,
        };
    };

    private doCalculation = () => {
        this.setState({ isLoading: true });
        const originType =
            this.state.originType || NewBusinessStore.getData()?.PensionApply?.DrawdownModel?.DrawdownType;
        const currType = this.props.data?.PensionApply?.DrawdownModel?.DrawdownType;
        let _data = JSON.parse(JSON.stringify(this.props.data));
        this.setState({ originType: currType });
        const originIsRegular = originType == DrawdownType.Regular;
        const currIsRegular = currType == DrawdownType.Regular;
        _data.PensionApply.DrawdownModel.ChangeInstructionType =
            (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
        NewBusinessAction.postInstruction(2, _data, () => {
            this.setState({ isLoading: false });
        });
    };

    private needIllHealth(data: ApplyModel) {
        return (
            LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)) &&
            !data?.PensionApply?.DrawdownModel?.InstructionId
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const isImmediateTaxFreeLumpSum =
            data?.SelectedProducts.find((ele) => ele.SubAccountType == SubAccountType.JuniorSipp)?.PensionType ==
            PensionType.ImmediateTaxFreeLumpSum;
        const isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.setState({ isLoading: true });
                        const params = getQueryParameters();
                        DrawdownCalculationAction.postDrawdown(
                            this.props.data?.PensionApply?.HierarchyId,
                            null,
                            (drawdownModel: DrawdownModel) => {
                                NewBusinessAction.getInstruction(params["id"]);
                                this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });
                            },
                            true
                        );
                    }}
                />
            );
        }
        return (
            <PartLoading isLoading={this.state.isLoading}>
                <WizardLinter
                    status={EWizardLinterStatus.PleaseComplete}
                    enabled={EWizardLinterHelper.shouldDisplay(SubAccountType.JuniorSipp)}
                >
                    <h2>Drawdown details</h2>
                    <>
                        {this.state.TailoredDrawdownAllowed == false && data?.PensionApply?.DrawdownModel?.DrawdownType == DrawdownType.Regular && (
                            <Alert alertType={AlertType.Error} message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage} />
                        )}
                        <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />
                        {data?.PensionApply?.DrawdownModel?.PreADay == false && (
                            <>
                                {SectionHeader("Drawdown details")}
                                <PensionProtection
                                    {...this.props}
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.PensionApply}
                                    onChange={(v) => this.onDataChange(onChange, v, data, "PensionApply")}
                                    process={ProcessType.NB}
                                />
                                <ProtectionInformation
                                    {...this.getComponentProps(data, onChange)}
                                    process={ProcessType.NB}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                />
                            </>
                        )}
                        
                        {data?.PensionApply?.DrawdownModel?.PreADay == false && (
                            <>
                                <InvestmentPathSelection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers}
                                    activityType={data?.ActivityType}
                                    isFirstCrystallisation={!isNotFirstCrystallisation}
                                    hardBlockforAdviserUser={UserStore.getUserInfo().IsAdviser && !this.state.hasDrawdownArrangement}
                                    onChange={(v) => {
                                        this.setState({ AdviceGiven: v.PersonalRecommendation })
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "PensionApply"),
                                            { InvestmentPathwayAnswers: v },
                                            data.PensionApply,
                                            "DrawdownModel"
                                        );
                                        this.onDataChange(
                                            (changes) =>
                                                this.onDataChange(onChange, changes, this.props.data, "PensionApply"),
                                            { AdviceGiven: v.PersonalRecommendation },
                                            this.props.data.PensionApply,
                                            "FinancialAdvice"
                                        );
                                        this.onDataChange(
                                            this.props.onChange,
                                            { AdviceGiven: v.PersonalRecommendation },
                                            this.props.data,
                                            "PensionApply"
                                        );
                                    }}
                                />

                                <hr />

                                <DrawdownTypeOption
                                    originType={
                                        this.state.originType ||
                                        NewBusinessStore.getData()?.PensionApply?.DrawdownModel?.DrawdownType
                                    }
                                    {...this.getComponentProps(data, onChange)}
                                    isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                    activityType={data?.ActivityType}
                                    PersonalRecommendation={
                                        data?.PensionApply?.DrawdownModel?.InvestmentPathwayAnswers
                                            ?.PersonalRecommendation
                                    }
                                />
                                {data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Regular && (
                                    <RegularCrystallisation
                                        {...this.getComponentProps(data, onChange)}
                                        process={ProcessType.NB}
                                        doCalculation={() => this.doCalculation()}
                                    />
                                )}

                                {(data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Capped ||
                                    data?.PensionApply?.DrawdownModel.DrawdownType == DrawdownType.Flexible) && (
                                        <CrystallisationDetailsSection
                                            isImmediateTaxFreeLumpSum={isImmediateTaxFreeLumpSum}
                                            modelData={this.props.data?.PensionApply}
                                            processType={ProcessType.NB}
                                            cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            pensionProtection={data?.PensionApply?.PensionProtection}
                                        />
                                    )}

                                {(data?.PensionApply?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.PensionApply?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                    !hasPrimaryProtection(data?.PensionApply?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.PensionApply?.PensionProtection) && (
                                        <>
                                            <LTABreakdownDetails
                                                doCalculation={() => this.doCalculation()}
                                                {...this.getComponentProps(data, onChange)}
                                                process={ProcessType.NB}
                                                lessThan75={ageLessThan75}
                                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionApply)}
                                            />
                                        </>
                                    )}

                                <TaxFreeLumpSumPayment
                                    doCalculation={this.doCalculation}
                                    process={ProcessType.NB}
                                    pensionProtection={data?.PensionApply?.PensionProtection}
                                    {...this.getComponentProps(data, onChange)}
                                    lessThan75={LessThanAge(
                                        75,
                                        JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth)
                                    )}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.PensionApply)}
                                />
                                {data?.SelectedProducts.find((ele) => ele.SubAccountType == SubAccountType.JuniorSipp)
                                    ?.PensionType == PensionType.ImmediateTaxFreeLumpSum && (
                                        <CrystallizationPerContribution
                                            {...this.getComponentProps(data, onChange)}
                                            modelData={this.props.data?.PensionApply}
                                        />
                                    )}
                                {data?.PensionApply?.DrawdownModel?.DrawdownType != DrawdownType.Regular && (
                                    <DIAC
                                        {...this.getComponentProps(data, onChange)}
                                        modelData={this.props.data?.PensionApply}
                                        existingAccount={false}
                                    />
                                )}
                                <OAC
                                    readonly={true}
                                    type={SubAccountType.JuniorSipp}
                                    onChange={(v) => { }}
                                    data={{
                                        OngoingAdviceCharge:
                                            data?.PensionApply?.DrawdownModel?.DrawdownAdviserCharge
                                                ?.OngoingAdviserCharge,
                                    }}
                                    onRef={(ref) => this.appendChild(ref)}
                                />
                                <ChargesOnIllustration {...this.getComponentProps(data, onChange)} />
                                <DrawdownPriceLock {...this.getComponentProps(data, onChange)} />
                                {showChooseAssetstoSell(
                                    data?.PensionApply?.DrawdownModel,
                                    ChooseAssetsToSellFor.Drawdown
                                ) && (
                                        <>
                                            <hr />
                                            <ChooseAssetsToSell
                                                {...this.getComponentProps(data, onChange)}
                                                tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                                assets={this.state.assetsTable}
                                            />
                                            {!data?.PensionApply?.DrawdownModel?.IsAcrossAllAssets && (
                                                <ChooseAssetsToSellTable
                                                    modelData={data?.PensionApply?.DrawdownModel}
                                                    data={
                                                        data?.PensionApply?.DrawdownModel
                                                            ?.PensionCommencementLumpSumAllocations || []
                                                    }
                                                    reason={ChooseAssetsToSellFor.Drawdown}
                                                    tableData={this.state.assetsTable}
                                                    onRef={(ref) => this.appendChild(ref)}
                                                    onChange={(v) => {
                                                        this.onDataChange(
                                                            (changes) =>
                                                                this.onDataChange(
                                                                    onChange,
                                                                    changes,
                                                                    data,
                                                                    "PensionApply"
                                                                ),
                                                            { PensionCommencementLumpSumAllocations: v },
                                                            data.PensionApply,
                                                            "DrawdownModel"
                                                        );
                                                    }}
                                                    processType={ProcessType.NB}
                                                />
                                            )}
                                        </>
                                    )}
                            </>
                        )}
                    </>
                </WizardLinter>
            </PartLoading>
        );
    }
}
